export default __webpack_public_path__ + "static/circle-logo-47c66d98f6a9d820b78d2f88588dd1d5.svg";